package com.eladfinish.bible.contest.screens.mikud.model

data class MikudPayload(
    val lineStart: Int,
    val lineEnd: Int,
    val schoolType: String,
)
